// extracted by mini-css-extract-plugin
export var button = "bW_qc";
export var button__darkBlue = "bW_qh";
export var button__edgesGrey = "bW_qj";
export var button__edgesRed = "bW_qf";
export var button__loader = "bW_qk";
export var button__red = "bW_qd";
export var button__transparent = "bW_qg";
export var loadingSpinner = "bW_ql";